"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpIsAdhocRendererFactory = void 0;
const CheckIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CheckIcon"));
const get_1 = __importDefault(require("lodash/get"));
const react_1 = __importDefault(require("react"));
const OpIsAdhocRendererFactory = (viewField) => (item) => {
    const value = (0, get_1.default)(item, viewField.propertyName);
    // for Adhoc Op, OpScheduledId is null, show tick when its null, else none
    if (!!value)
        return react_1.default.createElement(CheckIcon_1.default, { style: { margin: 'auto' }, size: 14 });
    else
        return null;
};
exports.OpIsAdhocRendererFactory = OpIsAdhocRendererFactory;
exports.default = exports.OpIsAdhocRendererFactory;
